// styles.js
const SIZE = {
    small: "16px",
    medium: "18px",
    large: "20px",
};

export default SIZE;